import * as types from 'store/types'

const initialState = {
  myTeams: [],
  sharedTeams: [],
  nonParticipatingTeams: [],
  loading: false
}

const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_TEAMS: {
      return {
        ...state,
        ...action.data,
        loading: false
      }
    }
    case types.RESET_TEAMS: {
      return initialState
    }
    default:
      return state
  }
}
export default teamReducer
